import angular from 'angular';
import referralModal from './referralModal';
import './style.scss';

export default angular
  .module('scenes.referral.scenes.referralModal', [])
  .component('referralModal', referralModal).name;
